export const offlineSupported = (): boolean => 'serviceWorker' in navigator && 'caches' in window

export const registerServiceWorker = async (): Promise<void> => {
	if (!offlineSupported()) return

	try {
		await navigator.serviceWorker.register('/sw.js', { scope: '/' })
	} catch {
		// Offline support is additive: a worker that will not register must not stop the app booting.
	}
}

const settled = (worker: ServiceWorker): Promise<void> =>
	new Promise((resolve, reject) => {
		const check = () => {
			if (worker.state === 'activated') resolve()
			if (worker.state === 'redundant') reject(new Error('The service worker went redundant while installing'))
		}

		worker.addEventListener('statechange', check)
		check()
	})

/** Force an update, then resolve for this deploy's worker or reject its failed installation. */
export const workerReady = async (): Promise<void> => {
	const registration = await navigator.serviceWorker.getRegistration('/')
	if (!registration) throw new Error('No service worker is registered')

	await registration.update()

	const pending = registration.installing ?? registration.waiting
	if (pending) return settled(pending)

	if (!registration.active) throw new Error('No service worker became active')
}
